import React from 'react'
import { Col, Row, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import {
  MiniDateCal,
  LeftCol,
  CenterCol,
  Wrapper,
  CalendarSection,
  StyledUlForCalendar,
  ListTag,
  CustomPopover,
  HoverText,
} from 'modules/Drives/CalendarView/Partials/MonthView/Style/style'
import DriveIcon from 'components/icons/DriveIcon'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import Cancel from 'components/icons/CancelIcon'
import ClockOrange from 'components/icons/ClockOrange'
import RequestIcon from 'components/icons/RequestIcon'

const MonthView = ({ fullscreen = false, drivesList }) => {
  const timing = time => {
    const [hours, minutes] = time.split(':')
    let newHours = parseInt(hours)
    let timeOfDay = 'am'

    if (newHours >= 12) {
      newHours -= 12
      timeOfDay = 'pm'
    }

    if (newHours === 0) {
      newHours = 12
    }
    const formattedTime = `${newHours}:${minutes} ${timeOfDay}`
    return formattedTime
  }
  function toPascalCaseDrive(str) {
    return str?.replace('_', ' ').replace(/(\w)(\w*)/g, function (g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase()
    })
  }
  const circleIcon = status => {
    switch (status) {
      case 'CONFIRMED':
        return <CheckCircleIcon />
      case 'PENDING':
        return <ClockOrange />
      case 'CANCELLED':
        return <Cancel />
      case 'REQUESTED':
        return <RequestIcon />
      default:
        break
    }
  }
  const dateCellRender = value => {
    // Safely extract drives and ensure all items have required properties
    const listOfDrives = drivesList?.list
      ?.map(item => item?.drive)
      ?.filter(drive => drive && drive.startDate && drive.endDate)
      
    const listData = listOfDrives?.filter(drive => {
      try {
        const startDate = drive.startDate
        const endDate = drive.endDate
        let endDates = new Date(endDate)
        endDates.setHours(new Date(endDate).getHours() + 12)
        return new Date(startDate) <= value && new Date(endDates) >= value
      } catch (error) {
        console.error('Error processing drive data:', error)
        return false
      }
    })
    return listData?.length > 0 ? (
      <CustomPopover
        content={
          <StyledUlForCalendar>
            <ListTag>
              <div>
                <Space>
                  {listData[0]?.corporate?.name}
                  {circleIcon(listData[0]?.corporateStatus)}
                </Space>
              </div>
              <lightText>{toPascalCaseDrive(listData[0]?.driveMode)}</lightText>
              <div>
                Time:
                <lightText>
                  {timing(listData?.[0]?.startTime) +
                    '-' +
                    timing(listData?.[0]?.endTime)}
                </lightText>
              </div>
            </ListTag>
            {listData?.length > 1 && (
              <ListTag>+{listData?.length - 1} Drives</ListTag>
            )}
          </StyledUlForCalendar>
        }
      >
        <HoverText> {<DriveIcon fill="blue" />}</HoverText>
      </CustomPopover>
    ) : null
  }
  return (
    <Wrapper>
      <CalendarSection>
        <Row>
          <Col span={24}>
            <MiniDateCal
              fullscreen={fullscreen}
              dateCellRender={dateCellRender}
              headerRender={({ value, type, onChange, onTypeChange }) => {
                const current = value.clone()
                const localeData = value.localeData()
                const months = []
                for (let i = 0; i < 12; i++) {
                  current.month(i)
                  months.push(localeData.months(current))
                }

                const month = value.month()
                const year = value.year()
              
                return (
                  <div>
                    <Row type="flex" justify="space-between">
                      <CenterCol span={4}>
                        <b>
                          {' '}
                          {months[month]} ,{year}
                        </b>

                        <p />
                      </CenterCol>
                      <LeftCol span={2}>
                        <LeftArrow
                          onClick={() => {
                            const newValue = value.clone()
                            newValue.month(month - 1)
                            onChange(newValue)
                          }}
                        />
                      </LeftCol>
                      <Col span={2}>
                        <RightArrow
                          onClick={() => {
                            const newValue = value.clone()
                            newValue.month(month + 1)
                            onChange(newValue)
                          }}
                        />
                      </Col>
                      <CenterCol span={8}>Total Drive -{drivesList?.totalDrive}</CenterCol>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                )
              }}
            />
          </Col>
        </Row>
      </CalendarSection>
    </Wrapper>
  )
}
const RightArrow = styled(RightOutlined)`
  cursor: pointer;
`

const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
`
export default MonthView
